import React, { Component } from 'react';
import Modal from '../../../../components/Modal';
import PropTypes from 'prop-types';
const pStyle = {
  textIndent: '25px',
};

export default class PacageDescriptionErrorModal extends Component {
  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    onHideModal: PropTypes.func.isRequired,
  };

  render() {
    const { showModal, onHideModal } = this.props;
    return (
      <Modal onClose={onHideModal} showModal={showModal}>
        <div className="justify">
          <p style={pStyle}>
            Уважаемые пользователи! В сервисе “Личный кабинет налогоплательщика физического лица”
            наблюдались кратковременные сбои при приеме документов, приложенных к Декларации 3-НДФЛ.
            Просим вас с пониманием отнестись к данному обстоятельству и повторно направить
            вложения, воспользовавшись кнопкой “Направить дополнительные документы” и выбрав
            необходимую Декларацию в разделе “Подать декларацию 3-НДФЛ”. Обращаем ваше внимание, что
            указанная ошибка не повлияет на процедуру проведения камеральной налоговой проверки.
          </p>
          <p style={pStyle}>
            В настоящее время сервис работает в штатном режиме. Приносим извинения за доставленные
            неудобства.
          </p>
        </div>
      </Modal>
    );
  }
}
